export async function findBoxByNumber(platform, number) {
    const boxes = platform.boxes;
    return boxes.filter(box => box.number == number).pop();
}
export async function findBoxesByNumbers(platform, numbers) {
    const boxes = platform.boxes;
    return boxes.filter(box => numbers.indexOf(box.number) >= 0);
}
export async function findBoxByLock(platform, lock) {
    const boxes = platform.boxes;
    return boxes.filter(box => box.lock == lock).pop();
}
export function getBoxTypes(boxes) {
    const types = new Set([...boxes.flatMap(box => box.types)]);
    return [...types].sort((t1, t2) => getBoxTypeOrdinal(t1) - getBoxTypeOrdinal(t2));
}
var BoxTypeOrder;
(function (BoxTypeOrder) {
    BoxTypeOrder[BoxTypeOrder["__LEAVE_UNUSED_BECAUSE_FALSE"] = 0] = "__LEAVE_UNUSED_BECAUSE_FALSE";
    BoxTypeOrder[BoxTypeOrder["XS"] = 1] = "XS";
    BoxTypeOrder[BoxTypeOrder["S"] = 2] = "S";
    BoxTypeOrder[BoxTypeOrder["S 32"] = 3] = "S 32";
    BoxTypeOrder[BoxTypeOrder["PrivateBox"] = 4] = "PrivateBox";
    BoxTypeOrder[BoxTypeOrder["Standard"] = 5] = "Standard";
    BoxTypeOrder[BoxTypeOrder["M"] = 6] = "M";
    BoxTypeOrder[BoxTypeOrder["M 32"] = 7] = "M 32";
    BoxTypeOrder[BoxTypeOrder["L"] = 8] = "L";
    BoxTypeOrder[BoxTypeOrder["XL"] = 9] = "XL";
    BoxTypeOrder[BoxTypeOrder["LG20"] = 10] = "LG20";
    BoxTypeOrder[BoxTypeOrder["LG46"] = 11] = "LG46";
    BoxTypeOrder[BoxTypeOrder["WelcomePackage"] = 12] = "WelcomePackage";
    BoxTypeOrder[BoxTypeOrder["SuitBag"] = 13] = "SuitBag";
    BoxTypeOrder[BoxTypeOrder["Master"] = 14] = "Master";
    BoxTypeOrder[BoxTypeOrder["MAX"] = 15] = "MAX";
})(BoxTypeOrder || (BoxTypeOrder = {}));
function getBoxTypeOrdinal(boxType) {
    return BoxTypeOrder[boxType] || BoxTypeOrder.MAX;
}
/**
 * @deprecated Because the returned description is always in German. Use `getBoxTypes` instead
 */
export class BoxSizeUtil {
    static map(size) {
        if (typeof size == "string") {
            return { name: size, description: SizeToDescription[size] || 'Unsupported size' };
        }
        else if (typeof size == "object" && size.name && size.description) {
            return size;
        }
        else {
            throw new TypeError('Could not create BoxSize from ' + size);
        }
    }
    static mapBoxes(boxes) {
        const types = new Set();
        for (const box of boxes) {
            for (const type of box.types) {
                types.add(type);
            }
        }
        return [...types].map(BoxSizeUtil.map).sort(BoxSizeUtil.compare);
    }
    static lookupEnum(size) {
        return getBoxTypeOrdinal(size.name);
    }
    static compare(a, b) {
        return BoxSizeUtil.lookupEnum(a) - BoxSizeUtil.lookupEnum(b);
    }
}
const SizeToDescription = {
    S: 'klein',
    M: 'mittel',
    L: 'groß',
    XL: 'extragroß',
};
//# sourceMappingURL=boxes.js.map